import "moment/locale/fr";
import "numeral/locales/fr";
import "moment/locale/en-gb";
import "numeral/locales/en-gb";
import "moment/locale/es";
import "numeral/locales/es";
import React from "react";
import {connect} from "react-redux";
import {Route, withRouter} from "react-router-dom";
import {IntlProvider, addLocaleData} from 'react-intl';
import Routes from "./routes.js";
import {setLocaleMessages} from "./actions/PageModule";

// const i18nLocaleData = {
// 	en: () => System.import('react-intl/locale-data/en'),
// 	fr: () => System.import('react-intl/locale-data/fr'),
// 	es: () => System.import('react-intl/locale-data/es')
// };

@withRouter
@connect(store => {
	return {
		messages: store.messages.messages,
		user: store.user.user,
	}
})
export default class App extends React.Component {

	// componentWillMount() {
	// 	const {dispatch, auth} = this.props;
	// 	const locale = (!!auth &&  !!auth.tokenParsed && auth.tokenParsed.locale) || "es";
	// 	// initialize react-intl locale
	// 	const messages = locale ? `/i18n/${locale}.json` : "/i18n/es.json"
	// 	i18nLocaleData[locale]().then(localeData => { addLocaleData(localeData)});
	// 	 dispatch(setLocaleMessages(messages));
	// }

	componentWillMount() {
        const url_path = this.props.location.pathname;
		if(url_path.endsWith('index.html')){
			window.location.href = `${url_path}${subscriptionDetails_url.path}`;
		}
    }

	render() {
		const {error, user, auth, history,location, messages} = this.props;
		const loading = ((user === undefined) && (error === undefined));
		const locale = (!!auth && auth.tokenParsed && auth.tokenParsed.locale) || "es";
		return (!!messages && !!Object.keys(messages).length &&
			<IntlProvider locale={locale} key={locale} history={history} messages={messages}>
				<Routes history={history} />
			</IntlProvider>

		);
	}
}



// WEBPACK FOOTER //
// ./src/opencell/App.jsx